<template>
  <div class="schedule-modal-container">
    <div class="schedule-modal-header" @click.self="hideActionTypesMenu">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
          <mask id="path-1-outside-1_5561_16400" maskUnits="userSpaceOnUse" x="0" y="0.244141" width="26" height="25" fill="black">
            <rect fill="white" y="0.244141" width="26" height="25"/>
            <path d="M7.85714 1.24414C6.92156 1.24414 6.01658 1.40103 5.16327 1.77603C4.99872 1.84108 4.88202 1.99223 4.86097 2.17016C4.83801 2.34809 4.91454 2.5222 5.05995 2.62552C5.20344 2.73075 5.39477 2.74797 5.55548 2.67144C6.26913 2.35957 7.03061 2.22373 7.85714 2.22373C11.1212 2.22373 13.7347 4.83725 13.7347 8.10128C13.7347 11.3653 11.1212 13.9788 7.85714 13.9788C4.59311 13.9788 1.97959 11.3653 1.97959 8.10128C1.97959 6.61276 2.54975 5.28113 3.44898 4.22501V5.50498C3.44707 5.681 3.5389 5.84554 3.69196 5.93547C3.84503 6.02348 4.03253 6.02348 4.18559 5.93547C4.33865 5.84554 4.43048 5.681 4.42857 5.50498V2.71353H1.63712C1.4611 2.71162 1.29656 2.80345 1.20663 2.95651C1.11862 3.10957 1.11862 3.29707 1.20663 3.45014C1.29656 3.6032 1.4611 3.69503 1.63712 3.69312H2.61288C1.62946 4.89274 1 6.41378 1 8.10128C1 11.8915 4.06696 14.9584 7.85714 14.9584C11.6473 14.9584 14.7143 11.8915 14.7143 8.10128C14.7143 4.31111 11.6473 1.24414 7.85714 1.24414ZM19.6122 1.24414C19.0765 1.24414 18.6327 1.68802 18.6327 2.22373V3.20332H13.9643C14.213 3.51136 14.4349 3.84044 14.6339 4.18292H18.6327V5.16251C18.6327 5.69822 19.0765 6.1421 19.6122 6.1421H20.5918C21.1276 6.1421 21.5714 5.69822 21.5714 5.16251V4.18292H24.0204V7.61149H15.669C15.6786 7.77411 15.6939 7.93483 15.6939 8.10128C15.6939 8.26774 15.6786 8.42845 15.669 8.59108H24.0204V23.7748H3.44898V14.5758C3.09885 14.3366 2.77551 14.0668 2.46939 13.7779V23.7748C2.46939 24.343 2.88074 24.7543 3.44898 24.7543H24.0204C24.5886 24.7543 25 24.343 25 23.7748V4.18292C25 3.61468 24.5886 3.20332 24.0204 3.20332H21.5714V2.22373C21.5714 1.68802 21.1276 1.24414 20.5918 1.24414H19.6122ZM19.6122 2.22373H20.5918V5.16251H19.6122V2.22373ZM7.84949 3.68547C7.57972 3.69121 7.36352 3.91315 7.36735 4.18292V8.02284C7.35204 8.12807 7.36926 8.23521 7.42092 8.32896C7.46492 8.41697 7.53571 8.48968 7.62181 8.53751L9.5236 9.96289C9.7398 10.1255 10.0459 10.0815 10.2085 9.8634C10.3712 9.6472 10.3272 9.34108 10.1091 9.17845L8.34694 7.85639V4.18292C8.34885 4.0509 8.29719 3.92271 8.20344 3.82896C8.10969 3.73521 7.9815 3.68355 7.84949 3.68547ZM15.2959 10.5503C15.1849 10.8889 15.0472 11.2142 14.8922 11.5299H16.6735V13.9788H13.2449V17.4074H10.7959V15.3621C10.4802 15.4903 10.1511 15.5936 9.81633 15.6797V17.4074H7.36735V15.9131C7.03444 15.8921 6.70727 15.8557 6.38776 15.7945V21.8156H21.0816V10.5503H15.2959ZM17.6531 11.5299H20.102V13.9788H17.6531V11.5299ZM14.2245 14.9584H16.6735V17.4074H14.2245V14.9584ZM17.6531 14.9584H20.102V17.4074H17.6531V14.9584ZM7.36735 18.387H9.81633V20.836H7.36735V18.387ZM10.7959 18.387H13.2449V20.836H10.7959V18.387ZM14.2245 18.387H16.6735V20.836H14.2245V18.387ZM17.6531 18.387H20.102V20.836H17.6531V18.387Z"/>
          </mask>
          <path d="M7.85714 1.24414C6.92156 1.24414 6.01658 1.40103 5.16327 1.77603C4.99872 1.84108 4.88202 1.99223 4.86097 2.17016C4.83801 2.34809 4.91454 2.5222 5.05995 2.62552C5.20344 2.73075 5.39477 2.74797 5.55548 2.67144C6.26913 2.35957 7.03061 2.22373 7.85714 2.22373C11.1212 2.22373 13.7347 4.83725 13.7347 8.10128C13.7347 11.3653 11.1212 13.9788 7.85714 13.9788C4.59311 13.9788 1.97959 11.3653 1.97959 8.10128C1.97959 6.61276 2.54975 5.28113 3.44898 4.22501V5.50498C3.44707 5.681 3.5389 5.84554 3.69196 5.93547C3.84503 6.02348 4.03253 6.02348 4.18559 5.93547C4.33865 5.84554 4.43048 5.681 4.42857 5.50498V2.71353H1.63712C1.4611 2.71162 1.29656 2.80345 1.20663 2.95651C1.11862 3.10957 1.11862 3.29707 1.20663 3.45014C1.29656 3.6032 1.4611 3.69503 1.63712 3.69312H2.61288C1.62946 4.89274 1 6.41378 1 8.10128C1 11.8915 4.06696 14.9584 7.85714 14.9584C11.6473 14.9584 14.7143 11.8915 14.7143 8.10128C14.7143 4.31111 11.6473 1.24414 7.85714 1.24414ZM19.6122 1.24414C19.0765 1.24414 18.6327 1.68802 18.6327 2.22373V3.20332H13.9643C14.213 3.51136 14.4349 3.84044 14.6339 4.18292H18.6327V5.16251C18.6327 5.69822 19.0765 6.1421 19.6122 6.1421H20.5918C21.1276 6.1421 21.5714 5.69822 21.5714 5.16251V4.18292H24.0204V7.61149H15.669C15.6786 7.77411 15.6939 7.93483 15.6939 8.10128C15.6939 8.26774 15.6786 8.42845 15.669 8.59108H24.0204V23.7748H3.44898V14.5758C3.09885 14.3366 2.77551 14.0668 2.46939 13.7779V23.7748C2.46939 24.343 2.88074 24.7543 3.44898 24.7543H24.0204C24.5886 24.7543 25 24.343 25 23.7748V4.18292C25 3.61468 24.5886 3.20332 24.0204 3.20332H21.5714V2.22373C21.5714 1.68802 21.1276 1.24414 20.5918 1.24414H19.6122ZM19.6122 2.22373H20.5918V5.16251H19.6122V2.22373ZM7.84949 3.68547C7.57972 3.69121 7.36352 3.91315 7.36735 4.18292V8.02284C7.35204 8.12807 7.36926 8.23521 7.42092 8.32896C7.46492 8.41697 7.53571 8.48968 7.62181 8.53751L9.5236 9.96289C9.7398 10.1255 10.0459 10.0815 10.2085 9.8634C10.3712 9.6472 10.3272 9.34108 10.1091 9.17845L8.34694 7.85639V4.18292C8.34885 4.0509 8.29719 3.92271 8.20344 3.82896C8.10969 3.73521 7.9815 3.68355 7.84949 3.68547ZM15.2959 10.5503C15.1849 10.8889 15.0472 11.2142 14.8922 11.5299H16.6735V13.9788H13.2449V17.4074H10.7959V15.3621C10.4802 15.4903 10.1511 15.5936 9.81633 15.6797V17.4074H7.36735V15.9131C7.03444 15.8921 6.70727 15.8557 6.38776 15.7945V21.8156H21.0816V10.5503H15.2959ZM17.6531 11.5299H20.102V13.9788H17.6531V11.5299ZM14.2245 14.9584H16.6735V17.4074H14.2245V14.9584ZM17.6531 14.9584H20.102V17.4074H17.6531V14.9584ZM7.36735 18.387H9.81633V20.836H7.36735V18.387ZM10.7959 18.387H13.2449V20.836H10.7959V18.387ZM14.2245 18.387H16.6735V20.836H14.2245V18.387ZM17.6531 18.387H20.102V20.836H17.6531V18.387Z" fill="#EA7801"/>
          <path d="M7.85714 1.24414C6.92156 1.24414 6.01658 1.40103 5.16327 1.77603C4.99872 1.84108 4.88202 1.99223 4.86097 2.17016C4.83801 2.34809 4.91454 2.5222 5.05995 2.62552C5.20344 2.73075 5.39477 2.74797 5.55548 2.67144C6.26913 2.35957 7.03061 2.22373 7.85714 2.22373C11.1212 2.22373 13.7347 4.83725 13.7347 8.10128C13.7347 11.3653 11.1212 13.9788 7.85714 13.9788C4.59311 13.9788 1.97959 11.3653 1.97959 8.10128C1.97959 6.61276 2.54975 5.28113 3.44898 4.22501V5.50498C3.44707 5.681 3.5389 5.84554 3.69196 5.93547C3.84503 6.02348 4.03253 6.02348 4.18559 5.93547C4.33865 5.84554 4.43048 5.681 4.42857 5.50498V2.71353H1.63712C1.4611 2.71162 1.29656 2.80345 1.20663 2.95651C1.11862 3.10957 1.11862 3.29707 1.20663 3.45014C1.29656 3.6032 1.4611 3.69503 1.63712 3.69312H2.61288C1.62946 4.89274 1 6.41378 1 8.10128C1 11.8915 4.06696 14.9584 7.85714 14.9584C11.6473 14.9584 14.7143 11.8915 14.7143 8.10128C14.7143 4.31111 11.6473 1.24414 7.85714 1.24414ZM19.6122 1.24414C19.0765 1.24414 18.6327 1.68802 18.6327 2.22373V3.20332H13.9643C14.213 3.51136 14.4349 3.84044 14.6339 4.18292H18.6327V5.16251C18.6327 5.69822 19.0765 6.1421 19.6122 6.1421H20.5918C21.1276 6.1421 21.5714 5.69822 21.5714 5.16251V4.18292H24.0204V7.61149H15.669C15.6786 7.77411 15.6939 7.93483 15.6939 8.10128C15.6939 8.26774 15.6786 8.42845 15.669 8.59108H24.0204V23.7748H3.44898V14.5758C3.09885 14.3366 2.77551 14.0668 2.46939 13.7779V23.7748C2.46939 24.343 2.88074 24.7543 3.44898 24.7543H24.0204C24.5886 24.7543 25 24.343 25 23.7748V4.18292C25 3.61468 24.5886 3.20332 24.0204 3.20332H21.5714V2.22373C21.5714 1.68802 21.1276 1.24414 20.5918 1.24414H19.6122ZM19.6122 2.22373H20.5918V5.16251H19.6122V2.22373ZM7.84949 3.68547C7.57972 3.69121 7.36352 3.91315 7.36735 4.18292V8.02284C7.35204 8.12807 7.36926 8.23521 7.42092 8.32896C7.46492 8.41697 7.53571 8.48968 7.62181 8.53751L9.5236 9.96289C9.7398 10.1255 10.0459 10.0815 10.2085 9.8634C10.3712 9.6472 10.3272 9.34108 10.1091 9.17845L8.34694 7.85639V4.18292C8.34885 4.0509 8.29719 3.92271 8.20344 3.82896C8.10969 3.73521 7.9815 3.68355 7.84949 3.68547ZM15.2959 10.5503C15.1849 10.8889 15.0472 11.2142 14.8922 11.5299H16.6735V13.9788H13.2449V17.4074H10.7959V15.3621C10.4802 15.4903 10.1511 15.5936 9.81633 15.6797V17.4074H7.36735V15.9131C7.03444 15.8921 6.70727 15.8557 6.38776 15.7945V21.8156H21.0816V10.5503H15.2959ZM17.6531 11.5299H20.102V13.9788H17.6531V11.5299ZM14.2245 14.9584H16.6735V17.4074H14.2245V14.9584ZM17.6531 14.9584H20.102V17.4074H17.6531V14.9584ZM7.36735 18.387H9.81633V20.836H7.36735V18.387ZM10.7959 18.387H13.2449V20.836H10.7959V18.387ZM14.2245 18.387H16.6735V20.836H14.2245V18.387ZM17.6531 18.387H20.102V20.836H17.6531V18.387Z" stroke="#EA7801" stroke-width="0.6" mask="url(#path-1-outside-1_5561_16400)"/>
        </svg>
        Scheduling actions
      </h2>
      <button @click="$emit('closeActionsModal')">
        <iconComponent symbol="cross" :width="24"/>
      </button>
    </div>
    <div class="schedule-modal-content" @click.self="hideActionTypesMenu">
    <div class="actions">

      <div v-for="(action, index) in updatedActions" :class="index === selectedActionIndex ? 'saved-action selected' : 'saved-action'" :key="index" @click="selectedActionIndex = index; hideActionTypesMenu();">
        <span class="label">{{actionTypes.find(actionType => actionType.type === action.type).label}}</span>
        <iconComponent symbol="trashcan" :width="16" @click="removeAction(index)"/>
      </div>

      <button class="button-yellow" @click="showActionTypes = true;">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
          <path fill="#EA7801" stroke="#EA7801" stroke-width=".3" d="M8.578 2.1h-.15v6.328H2.1v1.144h6.328V15.9h1.144V9.572H15.9V8.428H9.572V2.1h-.994Z"/>
        </svg>
        Add scheduled action
      </button>
      <div v-if="showActionTypes" class="custom-types-menu">
        <span v-for="action in actionTypes" :key="action.type" @click="createNewAction(action)">
          {{action.label}}
        </span>
      </div>
    </div>

    <div class="divider"/>

    <div class="action-content" @click="hideActionTypesMenu">
      <div v-if="showInputField('offerId')" class="input-container">
        <span class="label">Enginio Offer ID</span>
        <input type="text" v-model="updatedActions[selectedActionIndex].enginioOfferId"/>
      </div>

      <div v-if="showInputField('collectionId')" class="input-container">
        <span class="label">Enginio Collection ID</span>
        <input type="text" v-model="updatedActions[selectedActionIndex].enginioCollectionId"/>
      </div>

      <div v-if="showInputField('urlToSendTo')" class="input-container">
        <span class="label">URL to send to</span>
        <input type="text" v-model="updatedActions[selectedActionIndex].urlToSendTo"/>
      </div>

      <div v-if="showInputField('emailSubject')" class="input-container">
        <span class="label">Email subject</span>
        <input type="text" v-model="updatedActions[selectedActionIndex].emailSubject"/>
      </div>

      <div class="input-container-column">
        <div class="input-container">
          <span class="label">Days to delay action</span>
          <input type="text" v-model="updatedActions[selectedActionIndex].daysToDelayAction"/>
        </div>

        <div v-if="showInputField('userPoints')" class="input-container">
          <span class="label">Points per user</span>
          <input type="text" v-model="updatedActions[selectedActionIndex].userPoints"/>
        </div>

        <div v-if="showInputField('startDelayFrom')" class="input-container">
          <span class="label">Start delay from</span>
          <select class="select" :value="updatedActions[selectedActionIndex].trigger" @change="updatedActions[selectedActionIndex].trigger = $event.target.value">
            <option v-for="trigger in triggerTypes" :key="trigger.type" :value="trigger.type">
              {{ trigger.label }}
            </option>
          </select>
        </div>
      </div>

      <div v-if="showInputField('jsonPayload')" class="input-container">
        <span class="label">JSON objects as payload</span>
        <textArea v-model="updatedActions[selectedActionIndex].jsonPayload" style="height: 200px;"/>
      </div>

      <div v-if="showInputField('emailTemplate')" class="input-container">
        <span class="label">Email template - usable values</span>
        <CKEditor v-model="updatedActions[selectedActionIndex].emailTemplate" :config="editorConfig"/>
      </div>

      <div v-if="showInputField('emailReminderInfo')" class="input-container">
        <span class="label">Will send a reminder to all users who haven't completed the step.</span>
        <span>Delay will be calculated from receipt created at date.</span>
      </div>

    </div>
  </div>
  <div class="schedule-modal-footer" @click.self="hideActionTypesMenu">
    <button class="button-solid" @click="save">
      <iconComponent symbol="floppyDisk" :width="16" stroke="#FFF" fill="#FFF"/>
      Save
    </button>
  </div>
  </div>
</template>

<script>
import CKEditor from '../CKEditor/CKEditor.vue';

export default {
  name: "ActivationScheduling",
  components: {
    CKEditor
  },
  props: {
    actions: {
      type: Array,
      default: () => []
    }
  },
  created() {
    if (Object.keys(this.updatedActions).length === 0) {
      this.updatedActions.push({
        type: 'UNLOCK-OFFER',
        enginioOfferId: '',
        daysToDelayAction: '',
        trigger: 'CTA-DONE',
        userPoints: '',
        jsonPayload: '',
        emailTemplate: '',
        emailSubject: '',
        urlToSendTo: '',
        emailReminderInfo: '',
        enginioCollectionId: ''
      });
    }
  },
  data() {
    return {
      actionTypes: [
        {label: 'Unlock offer', type: 'UNLOCK-OFFER'},
        {label: 'Lock offer', type: 'LOCK-OFFER'},
        {label: 'Unlock collection', type: 'UNLOCK-COLLECTION'},
        {label: 'Add user points', type: 'ADD-USER-POINTS'},
        {label: 'Send custom payload', type: 'SEND-PAYLOAD'},
        {label: 'Send email', type: 'SEND-EMAIL'},
        {label: 'Send Receipt reminder', type: 'SEND-REMINDER-EMAIL'},
        {label: 'Send PR reminder', type: 'SEND-PR-REMINDER-EMAIL'},
        {label: 'Send Survey reminder', type: 'SEND-SURVEY-REMINDER-EMAIL'},
        {label: 'Send Address reminder', type: 'SEND-ADDRESS-REMINDER-EMAIL'},
        {label: 'Send Admin notification', key: 'SEND-ADMIN-NOTIFICATION-EMAIL'},
      ],
      triggerTypes: [
        {label: 'CTA done date', type: 'CTA-DONE'},
        {label: 'CTA done and receipt date', key: 'CTA-DONE-AND-RECEIPT-DATE'},
        {label: 'CTA done and created date', key: 'CTA-DONE-AND-CREATED-DATE'},
        {label: 'Receipt date', type: 'RECEIPT-DATE'},
        {label: 'Created date', type: 'CREATED-DATE'},
      ],
      editorConfig: {
        toolbar: [ [ 'Bold', 'Italic', 'Strike', '-', 'RemoveFormat', '-', 'NumberedList', 'BulletedList', '-',
          'Outdent', 'Indent', '-', 'Blockquote', '-', 'Styles', '-', 'Format', '-',  ] ]
      },
      updatedActions: this.fromDBEntities(this.actions),
      showActionTypes: false,
      selectedActionIndex: 0,
    }
  },
  methods: {
    showInputField(inputFieldName) {

      const selectedActionType = this.updatedActions[this.selectedActionIndex].type;

      switch (inputFieldName) {
        case 'offerId':
          return selectedActionType === 'UNLOCK-OFFER' || selectedActionType === 'LOCK-OFFER' || selectedActionType === 'ADD-USER-POINTS';
          case 'collectionId':
            return selectedActionType === 'UNLOCK-COLLECTION';
        case 'urlToSendTo':
          return selectedActionType === 'SEND-PAYLOAD';
        case 'emailSubject':
          return selectedActionType === 'SEND-EMAIL';
        case 'userPoints':
          return selectedActionType === 'ADD-USER-POINTS';
        case 'startDelayFrom':
          return !selectedActionType.includes('REMINDER-EMAIL');
        case 'jsonPayload':
          return selectedActionType === 'SEND-PAYLOAD';
        case 'emailTemplate':
          return selectedActionType === 'SEND-EMAIL';
        case 'emailReminderInfo':
          return selectedActionType.includes('REMINDER-EMAIL');
      }
    },
    createNewAction(action) {
      this.updatedActions.push({
        type: action.type,
        enginioOfferId: '',
        daysToDelayAction: '',
        trigger: 'CTA-DONE',
        userPoints: '',
        jsonPayload: '',
        emailTemplate: '',
        emailSubject: '',
        urlToSendTo: '',
        emailReminderInfo: '',
        enginioCollectionId: ''
      });

      this.selectedActionIndex = this.updatedActions.length - 1;
      this.hideActionTypesMenu();
    },
    removeAction(index) {
      this.updatedActions.splice(index, 1);
      this.selectedActionIndex = 0;
    },
    hideActionTypesMenu() {
      this.showActionTypes = false;
    },
    save() {
      const updatedActions = this.updatedActions.map(action => this.toDBEntity(action));
      this.$emit('saveActions', updatedActions)
    },
    fromDBEntities(actions) {
      return actions?.map(action => {
        return {
          type: action.type,
          enginioOfferId: action.offer_id,
          daysToDelayAction: action.delayed_duration,
          trigger: action.trigger,
          userPoints: action.points,
          jsonPayload: action.payload,
          emailTemplate: action.email_template,
          emailSubject: action.email_subject,
          urlToSendTo: action.endpoint,
          emailReminderInfo: '',
          enginioCollectionId: action.collection_id
        }
      })
    },
    toDBEntity(action) {
      return {
        type: action.type,
        trigger: action.trigger,
        delayed_duration: action.daysToDelayAction,
        offer_id: action.enginioOfferId,
        collection_id: action.enginioCollectionId,
        endpoint: action.urlToSendTo,
        payload: action.jsonPayload,
        email_subject: action.emailSubject,
        email_template: action.emailTemplate,
        points: action.userPoints
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.schedule-modal-container {
  display: flex;
  flex-direction: column;
  width: 1000px;

  .schedule-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    padding: 0 40px;
    border-radius: $company-modal-border-radius $company-modal-border-radius 0 0;
    background-color: #F2F2F2;

    h2 {
      display: flex;
      align-items: center;
      gap: 10px;

      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: -0.4px;

      svg {
        width: 32px;
        height: 32px;
      }
    }

    button {
      outline: 0;
      border: 0;
      margin-right: -6px;
    }
  }

  .schedule-modal-content {
      display: flex;
      flex-direction: row;
      height: 500px;
      min-width: 100%;
      padding: 24px 40px 24px 0;

      .actions {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 25%;
        gap: 8px;
        position: relative;

        overflow-y: auto;

        .button-yellow {
          font-size: 14px;
        }

        .saved-action {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          min-height: 65px;
          width: 100%;
          padding: 12px 8px 12px 24px;

          border-radius: 0 8px 8px 0;
          border-top: 1px solid #CCC;
          border-right: 1px solid #CCC;
          border-bottom: 1px solid #CCC;
          background: #FFF;

          .label {
            font-size: 16px;
          }

          &.selected {
            border-top: 2px solid $brand-yellow;
            border-right: 2px solid $brand-yellow;
            border-bottom: 2px solid $brand-yellow;

            font-weight: 700;
          }
        }

        .custom-types-menu {
          display: flex;
          flex-direction: column;
          background: $gray-500;
          justify-items: flex-start;
          align-items: flex-start;
          width: 200px;
          position: relative;


          gap: 8px;

          border-radius: 8px;
          margin-left: 16px;
          margin-top: -35px;
          padding-left: 12px;
          padding-top: 8px;
          padding-bottom: 8px;
          color: #FFFF;

          font-size: 16px;
          cursor: pointer;
        }
      }

      .divider {
        display: flex;
        width: 1px;
        height: 100%;
        flex-direction: column;
        align-items: flex-start;
        flex-shrink: 0;
        margin: 0 24px 0 8px;

        background: var(--enginio-silver-grey, #CCC);
      }

      .action-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: stretch;

        width: 75%;
        gap: 16px;

        .input-container {
          display: flex;
          flex-direction: column;
          width: 100%;

          .label {
            font-size: 16px;
            font-weight: 700;
            color: $charcoal-black;
          }
        }

        .input-container-column {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          justify-content: flex-start;
          width: 100%;

          gap: 16px;
        }
      }
    }

  .schedule-modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 87px;
    padding: 0 40px;
    border-radius: 0 0 $company-modal-border-radius $company-modal-border-radius;
    background-color: #F2F2F2;
  }
}

.select {

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;

  display: flex;
  padding: 14px 16px;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;

  border-radius: 8px;

  background: url("data:image/svg+xml,%3Csvg%20fill%3D'%23000000'%20height%3D'16px'%20width%3D'16px'%20version%3D'1.1'%20id%3D'Layer_1'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%20%0A%09%20viewBox%3D'0%200%20330%20330'%20xml%3Aspace%3D'preserve'%3E%0A%3Cpath%20id%3D'XMLID_225_'%20d%3D'M325.607%2C79.393c-5.857-5.857-15.355-5.858-21.213%2C0.001l-139.39%2C139.393L25.607%2C79.393%0A%09c-5.857-5.857-15.355-5.858-21.213%2C0.001c-5.858%2C5.858-5.858%2C15.355%2C0%2C21.213l150.004%2C150c2.813%2C2.813%2C6.628%2C4.393%2C10.606%2C4.393%0A%09s7.794-1.581%2C10.606-4.394l149.996-150C331.465%2C94.749%2C331.465%2C85.251%2C325.607%2C79.393z'%2F%3E%0A%3C%2Fsvg%3E") no-repeat calc(100% - 16px) center;
  -moz-appearance:none !important;
  -webkit-appearance: none !important;
}
</style>
